















import { Component, Vue } from "vue-property-decorator";
import CreateEmployeeForm from "@/components/user/CreateNewEmployeeForm.vue";

@Component({
  components: { CreateEmployeeForm }
})
export default class RegisterNewUser extends Vue {}
